import React, { useState, useEffect } from "react";
import axios from 'axios';
import * as API from "../../Endpoints/Endpoints";
import { useNavigate } from 'react-router-dom';

const GameCardAllocation = () => {
  const [formData, setFormData] = useState({
    gamecategory: "",
    gamename: "",
    cardgroup: "",
    cardname: "",
  });

  const [gameCategories, setGameCategories] = useState([]);
  const [gameNames, setGameNames] = useState([]);
  const [cardGroups, setCardGroups] = useState([]);

  const navigate = useNavigate();

  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(API.GET_ALLOCATION_API);
        const allocations = response.data;

        // Extract unique categories, game names, and card groups
        const categories = [...new Set(allocations.map(item => item.gamecategory))];
        const names = [...new Set(allocations.map(item => item.gamename))];
        const groups = [...new Set(allocations.map(item => item.cardgroup))];

        setGameCategories(categories);
        setGameNames(names);
        setCardGroups(groups);
      } catch (error) {
        console.error("Error fetching game card allocations:", error);
      }
    };

    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(API.POST_ALLOCATION_API, formData);

      if (response.status === 201) {
        console.log("Form Data Submitted Successfully:", response.data);
        setFormData({
          gamecategory: "",
          gamename: "",
          cardgroup: "",
          cardname: "",
        });
        alert("Data submitted successfully!");
        navigate('/cardalloctable');
      } else {
        alert("Failed to submit data.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred while submitting data.");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-lg p-8 bg-white rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold text-center text-gray-700 mb-6">
          Game Card Allocation Form
        </h2>
        <form onSubmit={handleSubmit}>
          {/* Game Category Dropdown */}
          <div className="mb-4">
            <label htmlFor="gamecategory" className="block text-sm font-medium text-gray-700 mb-1">
              Game Category
            </label>
            <select
              id="gamecategory"
              name="gamecategory"
              value={formData.gamecategory}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            >
              <option value="">Select Game Category</option>
              {gameCategories.map((category, index) => (
                <option key={index} value={category}>{category}</option>
              ))}
            </select>
          </div>

          {/* Game Name Dropdown */}
          <div className="mb-4">
            <label htmlFor="gamename" className="block text-sm font-medium text-gray-700 mb-1">
              Game Name
            </label>
            <select
              id="gamename"
              name="gamename"
              value={formData.gamename}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            >
              <option value="">Select Game Name</option>
              {gameNames.map((name, index) => (
                <option key={index} value={name}>{name}</option>
              ))}
            </select>
          </div>

          {/* Card Group Dropdown */}
          <div className="mb-4">
            <label htmlFor="cardgroup" className="block text-sm font-medium text-gray-700 mb-1">
              Card Group
            </label>
            <select
              id="cardgroup"
              name="cardgroup"
              value={formData.cardgroup}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            >
              <option value="">Select Card Group</option>
              {cardGroups.map((group, index) => (
                <option key={index} value={group}>{group}</option>
              ))}
            </select>
          </div>

          {/* Card Name Input */}
          <div className="mb-4">
            <label htmlFor="cardname" className="block text-sm font-medium text-gray-700 mb-1">
              Card Name
            </label>
            <input
              type="text"
              id="cardname"
              name="cardname"
              value={formData.cardname}
              onChange={handleChange}
              placeholder="Enter card name"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-[#e64a32] text-white py-2 px-4 rounded-lg hover:bg-[#e64a32] focus:outline-none"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default GameCardAllocation;
